import {TaskbarEntryIconButton} from "./TaskbarMenuEntry";

export class FullscreenWidget extends TaskbarEntryIconButton {
    isFullscreen: boolean = false;
    constructor() {
        super("bi-fullscreen", undefined, () => {
            if (this.isFullscreen) {
                document.exitFullscreen().then(() => {
                    this.isFullscreen = false;
                });
            } else {
                document.documentElement.requestFullscreen().then(() => {
                    this.isFullscreen = true;
                });
            }
        });
    }
}